import React, { useState } from 'react';
import { Helmet } from 'react-helmet'; // ✅ import Helmet
import { ChevronDown, ChevronUp } from 'lucide-react';


function FAQ() {
  const [activeIndex, setActiveIndex] = useState(null);

  const questions = [
    {
      question: 'Which industries does Pravisht serve?',
      answer:
        "Pravisht has experience working across various industries and has developed applications on client platforms. They have successfully engaged with some of the world's Fortune 500 corporations by delivering projects on time and within budget."
    },
    {
      question: 'Does Pravisht offer mobile application development?',
      answer:
        "Yes, Pravisht provides mobile solutions across iOS, Android, and UWP platforms using frameworks like Flutter, Xamarin, React Native, Ionic, as well as native development."
    },
    {
      question: 'What is Pravisht approach to project development?',
      answer:
        "Pravisht supports clients at every level of the software development life cycle, from ideation and business analysis to prototyping, development, and implementation of comprehensive solutions."
    },
    {
      question: 'Does Pravisht provide AI and ML solutions?',
      answer:
        "Yes, Pravisht utilizes AI approaches that allow systems to learn directly from data. Machine Learning assists organizations in personalizing customer experiences, automating processes, and implementing solutions that revolutionize customer interactions."
    },
    {
      question: 'What is the typical timeline for a web development project?',
      answer:
        "The timeline varies depending on the project's complexity and requirements. A standard corporate website may take approximately 2-4 weeks, while more complex projects could extend to 6-8 weeks or longer."
    },
    {
      question: 'Do you provide ongoing website maintenance and support?',
      answer:
        "Yes, ongoing maintenance and support services are offered to ensure your website remains up-to-date, secure, and functioning smoothly."
    },
    {
      question: 'How do you ensure website security?',
      answer:
        "Websites are developed with security best practices, including SSL certificates, regular updates, and secure coding standards, to protect against vulnerabilities."
    }
  ];

  const toggleAccordion = (index) => {
    setActiveIndex(prevIndex => (prevIndex === index ? null : index));
  };

  return (
    <div className='FAQ-container'>
      {/* ✅ SEO Meta Tags */}
      {/* <Helmet>
        <title>FAQ | Pravisht Digital</title>
        <meta name="description" content="Get answers to frequently asked questions about Pravisht's services, including mobile apps, AI/ML, web development, and ongoing support." />
        <meta name="keywords" content="FAQ, Pravisht, Pravisht Digital, mobile development, AI, ML, web support, software solutions" />
        <meta property="og:title" content="FAQ | Pravisht Digital" />
        <meta property="og:description" content="Explore answers to common questions about Pravisht's technology offerings and project approach." />
        <meta property="og:type" content="website" />
        <meta name="author" content="Pravisht Digital" />
      </Helmet> */}
      <div className='FAQ-header'>
        <p>FAQ’S</p>
        <h1>Find the answers you need</h1>
        <hr className="portfolio-horizontalline"></hr>
      </div>
      <div id="wrapper">
        <ul className='wrapper-ul'>
          {questions.map((item, index) => (
            <li key={index} onClick={() => toggleAccordion(index)}>
              {/* <h2>{item.question}</h2>
             {activeIndex === index ? (
                <ChevronUp size={20} className="icon open" />
                ) : (
                <ChevronDown size={20} className="icon" />
                )} */}
                <h2 className='accordian-header'>{item.question}
                {activeIndex === index ? (
                    <ChevronUp size={20} className="icon open" />
                ) : (
                    <ChevronDown size={20} className="icon" />
                )}
                </h2>
              <p
                style={{
                  maxHeight: activeIndex === index ? '800px' : '0',
                  opacity: activeIndex === index ? 1 : 0,
                  transform: activeIndex === index ? 'translate(0, 0)' : 'translate(0, 50%)',
                  transition: 'all 0.5s ease',
                  overflow: 'hidden',
                  marginTop: activeIndex === index ? '14px' : '0',
                }}
              >
                {item.answer}
              </p>
              <hr></hr>
            </li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default FAQ;
